import React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableFooter from '@mui/material/TableFooter'
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import './applicationTableParentInfo.scss' 


const  ApplicationTableParentInfo = ({ applicationData}) => {

  
  return (
            
    <div className=''>

        <div className='item'>

            <div className="details">

            {
                applicationData.fatherAlive === "fatherAlive"

                ?

                <div className='detailItem'>
                    <span className='itemKey'>Father:</span>
                    <span className='itemValue'>Alive</span>
                </div>

                :

                    <div className='detailItem'>
                        <span className='itemKey'>Father:</span>
                        <span className='itemValue'>Deceased</span>
                    </div>
            }    
            
                <div className='detailItem'>
                    <span className='itemKey'>Firstname:</span>
                    <span className='itemValue'>{applicationData.fatherFirstname}</span>
                </div>
                <div className='detailItem'>
                    <span className='itemKey'>Lastname:</span>
                    <span className='itemValue'>{applicationData.fatherLastname}</span>
                </div>
                <div className='detailItem'>
                    <span className='itemKey'>Othername:</span>
                    <span className='itemValue'>{applicationData.fatherOthername}</span>
                </div>

                <div className='detailItem'>
                    <span className='itemKey'>Address:</span>
                    <span className='itemValue'>{applicationData.fatherAddress}</span>
                </div>
                <div className='detailItem'>
                    <span className='itemKey'>DOB:</span>
                    <span className='itemValue'>{applicationData.dateOfBirthFather}</span>
                </div>
                <div className='detailItem'>
                    <span className='itemKey'>Status:</span>
                    <span className='itemValue'>{applicationData.fatherMaritalStatus}</span>
                </div>

            </div>
        </div>

        <div className='item'>
       
            <div className="details">

            {
                applicationData.motherAlive === "motherAlive"

                ?

                <div className='detailItem'>
                    <span className='itemKey'>Mother:</span>
                    <span className='itemValue'>Alive</span>
                </div>

                :

                    <div className='detailItem'>
                        <span className='itemKey'>Mother:</span>
                        <span className='itemValue'>Deceased</span>
                    </div>
            }    
            
                <div className='detailItem'>
                    <span className='itemKey'>Firstname:</span>
                    <span className='itemValue'>{applicationData.motherFirstname}</span>
                </div>
                <div className='detailItem'>
                    <span className='itemKey'>Lastname:</span>
                    <span className='itemValue'>{applicationData.motherLastname}</span>
                </div>
                <div className='detailItem'>
                    <span className='itemKey'>Othername:</span>
                    <span className='itemValue'>{applicationData.motherOthername}</span>
                </div>

                <div className='detailItem'>
                    <span className='itemKey'>Address:</span>
                    <span className='itemValue'>{applicationData.motherAddress}</span>
                </div>
                <div className='detailItem'>
                    <span className='itemKey'>DOB:</span>
                    <span className='itemValue'>{applicationData.dateOfBirthMother}</span>
                </div>
                <div className='detailItem'>
                    <span className='itemKey'>Marital Status:</span>
                    <span className='itemValue'>{applicationData.motherMaritalStatus}</span>
                </div>
            
            </div>
            </div>
        </div>
   
  );
}

export default ApplicationTableParentInfo